import { Link } from 'react-router-dom';
import { comics, testimonials } from '@/mocks/comics';

export default function Testimonials() {
  const finished = comics.filter((c) => c.status === '已完结').slice(0, 4);

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            读者口碑
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
            听听韩漫爱好者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id + t.date}
              className="p-5 rounded-xl bg-background-50 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-800">{t.name}</p>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < t.rating
                            ? 'ri-star-fill text-accent-500'
                            : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t.comment}
              </p>
              <p className="mt-3 text-xs text-foreground-400">{t.date}</p>
            </div>
          ))}
        </div>

        <div className="mt-14">
          <div className="flex items-center justify-between mb-8">
            <h3 className="font-heading text-xl font-bold text-foreground-900">
              已完结佳作
            </h3>
            <Link
              to="/category/action"
              className="text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap flex items-center gap-1"
            >
              查看全部
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
            {finished.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.id}`}
                className="group cursor-pointer"
              >
                <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} - 韩漫之家`}
                    title={`${comic.title} - 已完结韩漫免费读`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-3">
                    <span className="px-2 py-0.5 rounded-full text-[10px] font-medium bg-accent-500 text-background-50">
                      已完结
                    </span>
                  </div>
                </div>
                <h3 className="mt-3 text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-400">{comic.author}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}